module.exports = __webpack_public_path__ + "static/img/17.ca087a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/17.jpg
// module id = G/I2
// module chunks = 1